import dynamic from 'next/dynamic';
import { EditableComponent } from '@adobe/aem-react-editable-components';
export { CancelTripModal } from './CancelTripModal';

const CancelTripModal = dynamic(() => import('./CancelTripModal').then(mod => mod.CancelTripModal));

export const CancelTripModalConfig = {
  emptyLabel: 'canceltripmodal',
  isEmpty: false,
  resourceType: `mi-aem-account/components/content/canceltripmodal`,
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const CancelTripModalEditable = (props: any) => {
  return (
    <EditableComponent config={CancelTripModalConfig} {...props}>
      <CancelTripModal {...props} />
    </EditableComponent>
  );
};
